import React from 'react';

const Development = ({ t }) => {
  return (
    <section id="development" data-testid="development-section" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        {/* Mobile: Text above, Image below */}
        <div className="lg:hidden">
          <h2 className="text-xl sm:text-2xl font-light text-gray-900 mb-5 leading-snug">
            {t.development.title}
          </h2>
          <div className="space-y-4 text-gray-600 leading-relaxed text-sm mb-8">
            <p>{t.development.text1}</p>
            <p>{t.development.text2}</p>
          </div>
          <img 
            src="/images/renders/HA01b.jpg" 
            alt="Hexaparks industrial development facade"
            className="w-full h-auto border border-gray-200"
          />
        </div>

        {/* Desktop: Side by side */}
        <div className="hidden lg:grid lg:grid-cols-12 lg:gap-12 xl:gap-16 items-start">
          <div className="lg:col-span-5">
            <h2 className="text-2xl xl:text-3xl font-light text-gray-900 mb-6 leading-snug">
              {t.development.title}
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed text-sm">
              <p>{t.development.text1}</p>
              <p>{t.development.text2}</p>
            </div>
          </div>
          <div className="lg:col-span-7">
            <img 
              src="/images/renders/HA01b.jpg" 
              alt="Hexaparks industrial development facade"
              className="w-full h-auto border border-gray-200"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Development;
